import { API_URL_All } from "../api";

/** Cùng logic hiển thị avatar với menu top (user.picture + config.userPath). */
export const resolveAvatarSrc = (picture, fallbackUserPath) => {
  const raw = picture || fallbackUserPath;
  if (!raw) return null;
  if (raw.startsWith("http://") || raw.startsWith("https://")) return raw;
  const base = (API_URL_All || "").replace(/\/$/, "");
  const path = raw.startsWith("/") ? raw : `/${raw}`;
  return `${base}${path}`;
};

export const resolveUserAvatarSrc = ({ user, config, entityPicture, previewUrl } = {}) => {
  if (previewUrl) return previewUrl;
  const picture = entityPicture ?? user?.picture;
  return resolveAvatarSrc(picture, config?.userPath);
};
